import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import { $menuState, getMenuItemByIdFx, getMenuItemsByPageIdFx } from '@nx-frontend/shared/store/feature-menu-tree';
import { $page } from '@nx-frontend/shared/store/portal-page';
import { MenuItem, MenuType, PortalMenuTypes } from '@nx-frontend/shared/types/menu';

interface GetCurrentMenuItemProps {
  menuTypes?: MenuType[];
}

interface MenuItemResult {
  menuType: MenuType;
  currentItem: MenuItem;
  parentItem?: MenuItem;
}

export const useGetParentMenuItem = ({ menuTypes = PortalMenuTypes }: GetCurrentMenuItemProps = {}):
  | MenuItemResult
  | undefined => {
  const [parentMenuItem, setParentMenuItem] = useState<MenuItemResult | undefined>(undefined);
  const [page, menuState, getMenuItemsByPageId, getMenuItemById] = useUnit([
    $page,
    $menuState,
    getMenuItemsByPageIdFx,
    getMenuItemByIdFx,
  ]);

  useEffect(() => {
    const findParentMenuItem = async () => {
      const menuItem = await getMenuItemsByPageId({
        menuTypes,
        pageId: page.id,
      });
      if (menuItem?.item.parentId == null) {
        return false;
      }
      const parentMenuItem = await getMenuItemById({
        menuType: menuItem.menuType,
        id: menuItem.item.parentId,
      });
      setParentMenuItem({ currentItem: menuItem.item, parentItem: parentMenuItem, menuType: menuItem.menuType });
    };
    findParentMenuItem();
  }, [page.id, menuState, getMenuItemsByPageId, menuTypes, getMenuItemById]);

  return parentMenuItem;
};
